/** «Кличат Плюс» и бусты серверов (docs/api/openapi.yaml, раздел Billing). */
import { authed } from './auth'
import type { User } from '@/types/api'

export interface Plan {
  ID: string
  Kind: 'plus' | 'boost'
  Name: string
  PriceRub: number
  Months: number
}

export interface GuildLimits {
  tier: number
  emojis: number
  stickers: number
  /** Слоты звуковой панели. */
  sounds: number
  bitrate_kbps: number
  upload_mb: number
  stream_height: number
  stream_fps: number
}

export interface UserLimits {
  plus: boolean
  upload_mb: number
  message_len: number
  stream_height: number
  stream_fps: number
  any_emoji: boolean
  animated_avatar: boolean
}

export interface Showcase {
  plans: Plan[]
  enabled: boolean
  tiers: GuildLimits[]
  boosts: number[]
  plus: UserLimits
  free: UserLimits
  currency: string
}

export interface Boost {
  id: string
  guild_id: string | null
  ends_at: string
}

export interface BillingStatus {
  plus: boolean
  plus_until: string | null
  auto_renew: boolean
  boosts: Boost[]
  boosts_free: number
  limits: UserLimits
  provider: string
  payments: { id: string; plan: string; amount_rub: number; status: string; created_at: string }[]
}

export interface GuildPremium {
  tier: number
  boosts: number
  next_tier: number | null
  next_need: number | null
  limits: GuildLimits
  /** Кто бустит: одна строка на человека — сколько бустов поставил и с какого дня (с первого из них). */
  boosters: { user_id: string; username: string; user: User; boosts: number; since: string | null }[]
}

/** Приглашённые: сколько привёл и сколько осталось до месяца Плюса. */
export interface Referrals {
  code: string
  invited: number
  qualified: number
  pending: number
  need: number
}

export const billingApi = {
  showcase: () => authed<Showcase>('/billing/plans'),
  referrals: () => authed<Referrals>('/billing/referrals'),
  status: () => authed<BillingStatus>('/billing/status'),
  checkout: (plan: string) => authed<{ confirmation_url: string }>('/billing/checkout', { method: 'POST', body: JSON.stringify({ plan }) }),
  guild: (guildId: string) => authed<GuildPremium>(`/guilds/${guildId}/premium`),
  boost: (guildId: string) => authed<Boost>(`/guilds/${guildId}/boosts`, { method: 'POST' }),
  unboost: (guildId: string, boostId: string) => authed<void>(`/guilds/${guildId}/boosts/${boostId}`, { method: 'DELETE' }),
  grantPlus: (userId: string, months: number) => authed<{ premium_until: string }>(`/moderation/billing/users/${userId}/plus`, { method: 'POST', body: JSON.stringify({ months }) }),
  grantBoosts: (userId: string, count: number, months = 1) => authed<{ granted: number }>(`/moderation/billing/users/${userId}/boosts`, { method: 'POST', body: JSON.stringify({ count, months }) }),
}
